module.exports = __webpack_public_path__ + "img/boutir.9faa3e82.png";